import { Props } from "@greeter/matter";
import { classNames } from "@greeter/util";
import css from "./AlertTitle.module.scss";

export function AlertTitle({className, ...props}: Props) {
  return <h4 {...classNames(className, css.AlertTitle)} {...props} />
}
